import React from "react";
import { Container, Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import faqData from "../../data/faqData";
import "./FAQPage.css";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

export default function FAQPage() {
    const { t } = useTranslation();

    return (
        <div className="faqPage">
            <div className="faqPageBanner text-center">
                <div className="page-banner-content">
                    <h3>{t("faq.banner.subtitle")}</h3>
                    <h1>{t("faq.banner.title")}</h1>
                </div>
            </div>

            <Container fluid>
                <div className="section-spacing">
                    <p className="brand-section-desc text-center mb-0">
                        {t("faq.intro.line1")}
                    </p>
                    <p className="brand-section-desc text-center mb-0">
                        {t("faq.intro.line2")}
                    </p>
                </div>

                <div className="faq-accordion-wrap">
                    <Accordion className="brand-accordion" defaultActiveKey="0" alwaysOpen={false}>
                        {faqData.map((item, index) => (
                            <Accordion.Item
                                className="brand-acc-item"
                                eventKey={String(index)}
                                key={item.id}
                            >
                                <Accordion.Header className="brand-acc-header">
                                    {t(item.qKey)}
                                </Accordion.Header>
                                <Accordion.Body className="brand-acc-body">
                                    <p className="faq-answer">{t(item.aKey)}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>
            </Container>

            <div className="section-spacing-top">
                <AftersalesSupportSection />
            </div>
        </div>
    );
}